import { defineStore } from "pinia";
import axios from 'axios';
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
export const useGajiSkemaKomponenStore = defineStore('gajiSkemaKomponenStore', {
    state: () => ({
        data: null
    }),
    onInit() {
        this.get();
    },
    persist: true,
    getters: {
        filter(){
            return this.data.filter(g => g.nama);
        }
    },
    actions: {
        async get() {
          if (!this.data) {
            try {
              const config = {
                headers: {
                  Authorization: api.defaults.headers.common["Authorization"],
                  "content-type": "application/json",
                },
              };
              const response = await axios.get( `${API_BASE_URL}/gajiSkemaKomponen`,config);  // Replace with your API endpoint
              this.data = response.data;
            } catch (error) {
              console.error('gajiSkemaKomponen Error fetching:', error);
            }
          }
          return this.data;
        },
        // reset(){
        //     this.data = null;
        //     this.get();
        // }
        async reset() {  // Add async
          this.data = null;  // Clear the store
          
          const newData = await this.get();  // Fetch new data
          
          this.data = newData;  // Store the fetched data
          return this.data;  // Ensure reset() returns the data
      }
        
    },
     

});